import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Animate, Layout } from 'ds';
import { RequestState } from 'ds/types';
import { apiTrack } from 'lib/analytics';
import { validateEmail, validatePhone } from 'shared';
import {
  selectServicesRequest,
  selectServicesRequestHasMovedIn,
  selectServicesRequestUser
} from 'store/ServicesRequest/selectors';
import { useAppSelector } from 'store/hooks';

import StepContainer from './StepContainer';
import StepTitle from './StepTitle';
import UserFields from './UserFields';
import { createServicesRequest } from './requests';
import { generateServicesRequestStepPath, isCreatableServicesRequest } from './utils';

interface Props {}

const ServicesRequestContact: React.FC<Props> = () => {
  const servicesRequest = useAppSelector(selectServicesRequest);
  const { firstname: firstName, lastname: lastName, email, phone, callingCode } =
    useAppSelector(selectServicesRequestUser) || {};
  const { isMobile } = useContext(media);
  const history = useHistory();
  const [requestState, setRequestState] = useState<RequestState>('ready');
  const hasMovedIn = useAppSelector(selectServicesRequestHasMovedIn);

  const isValidServicesRequest =
    firstName && lastName && validateEmail(email, true) && validatePhone(phone, true) && callingCode;

  const handleSubmit = async () => {
    setRequestState('in_progress');

    if (!isCreatableServicesRequest(servicesRequest)) {
      setRequestState('ready');
      return;
    }

    createServicesRequest(servicesRequest);
    apiTrack('Services Request Submitted', servicesRequest);
    history.push(generateServicesRequestStepPath({ step: 'confirmation' }));
  };
  return (
    <StepContainer
      step="contact"
      ctaDisabled={!isValidServicesRequest || requestState === 'in_progress'}
      backHref={generateServicesRequestStepPath({ step: hasMovedIn ? 'move' : 'set-up' })}
      onSubmit={handleSubmit}
      requestState={requestState}
      stepCompletedEventValue={{ firstName, lastName, email, phone, callingCode }}
      {...(isMobile ? { textLayoutProps: { paddingY: 48 } } : {})}
      mobileStyle="compact"
      stepName="contact form"
    >
      <StepTitle>How can I get in touch?</StepTitle>
      {isMobile ? (
        <Layout paddingX={24} paddingBottom={24} paddingTop={24} width="100%">
          <UserFields />
        </Layout>
      ) : (
        <Animate>
          <UserFields />
        </Animate>
      )}
    </StepContainer>
  );
};

export default ServicesRequestContact;
